

  <body>

    <h2>Informations générales</h2>
    
    <div class="card" *ngIf="user">
      <img src="../../assets/img_avatar.png" *ngIf="user.civilite=='Monsieur'" else alt="Avatar" style="width:10% ;height:10%">
      <img src="../../assets/img_avatar2.png" *ngIf="user.civilite!='Monsieur'" alt="Avatar" style="width:10% ;height:10%">
      <div class="container-fluid">
        <h4>Utilisateur connecté:</h4>
        <hr>
        <h4><b>{{ user.firstname }} {{ user.lastname }}</b></h4> 
        <h4>Crée le(heure GMT):<b>  {{ user.created | customDate}}</b></h4>
        <h4>Dernière modificationle(heure GMT):<b>  {{ user.updated | customDate}}</b></h4>
        <h4>Numéro mobile:<b>  {{ user.mobile }}</b></h4>
        <h4>Type utilisateur:<b *ngIf="user.usertype=='Clientpor'"> Client porteur</b><b *ngIf="user.usertype=='Clientcomm'"> Client commerçant</b><b *ngIf="user.usertype=='Metier'">Métier</b>
          <b *ngIf="user.usertype=='Agence'">Agence</b><b *ngIf="user.usertype=='Comite arbitrage'">Comité Arbitrage</b></h4>
        <h4 *ngIf="user.indicatifagence">Indicatif agence:<b >{{ user.indicatifagence }}</b></h4>
        <h4 *ngIf="user.usertype=='Clientcomm'">Raisonsociale:<b>  {{ user.raisonsociale }}</b></h4>
        <h4>Email:<b *ngIf="user.contact">{{ user.contact }}</b><b *ngIf="!user.contact">{{ user.email }}</b></h4>
        <h4>Code client<b>  {{ user.clientcode }}</b></h4>
        <h4>code banque:<b>  {{ user.banque |changebanque}}</b></h4>
        <h4 *ngIf="user.usertype=='Clientpor'||user.usertype=='Clientcomm'">Numéro de compte:<b>  {{ user.compte }}</b></h4>
        <h4 *ngIf="user.usertype=='Clientpor'">Numéro de carte:<b>  {{ user.carte }}</b></h4>
        <h4 *ngIf="user.usertype=='Clientcomm'">Numéro d'affiliation:<b>  {{ user.affiliation }}</b></h4>
        <h4 *ngIf="user.usertype=='Clientcomm'">Numéro de terminal:<b>  {{ user.terminal }}</b></h4>
        <h4 *ngIf="user.ficheUrl">Carte d'identification fiscale: <b><a href="{{user.ficheUrl}}" target="_blank">Aperçu CIF</a></b></h4>    
      </div>
      <div class="container-fluid">
      <button type="button" class="btn btn-success" *ngIf="currentUser.role=='superadmin'" (click)="resetpassword()">Réinitialiser Mot de passe</button>
      <button type="button" class="btn btn-danger"*ngIf="currentUser.role=='superadmin'"(click)="onDelete()">supprimer utilisateur</button>
      <button type="button" class="btn btn-primary"*ngIf="currentUser.role=='superadmin'"[routerLink]="['/auth/modify-user/{{user._id}}']" target="_self">Modifier données utilisateur</button>
    </div>
    </div>   
    </body>
